<template>

    <v-card id="card">

        <div class="setting-container">
            
            <div class="setting-main">

                <!-- <div class=" d-flex justify-end">
                    <section class="pa-4" style="position: sticky; top: 50px;">
                        <v-btn
                            @click="$router.go(-1)"
                            id="goBack"
                            :color="this.$vuetify.theme.themes['dark']['primary']"
                            class="white--text mr-4"
                        >
                            回上一頁
                        </v-btn>
                        <v-btn
                            id="save"
                            @click="saveMarketingCard"
                            v-intersect.quiet="{
                                handler: onIntersectWrapper(4),
                                options: {
                                    threshold: [0, 1.0]
                                }
                            }"
                            :color="this.$vuetify.theme.themes['dark']['primary']"
                            class="white--text"   
                        >
                            保存    
                        </v-btn>
                    </section>				
                </div> -->
                
                <article
                    class="basic-setting-container"
                    id="basic-setting"
                    
                >
                    <h4
                        class="basic-setting-title d-flex justify-space-between"
                        v-intersect.quiet="{
                            handler: onIntersectWrapper(1),
                            options: {
                                threshold: [0, 0.2, 1.0]
                            }
                        }"
                    >
                        基本設定
                    </h4>

                    <!-- {{modeCardSetting}} -->
                    
                    <MarketingCardCategories 
                        v-if="category_setting.is_show"
                        :default_row="category_setting.row"
                        :default_city="category_setting.default_city"
                        :default_district="category_setting.default_district"
                        @handle-row="handleRow"
                        @selected-city="selected_city"
                        @selected-district="selected_district"
                        :loadOldSettingData="load_old_setting_data"
                        :oldSettingCardRow="Number(row)"
                    />

                    <div 
                        class="input-container"
                        
                    >
                        <section
                            id="setting_name"
                        >
                            <label>
                                <v-icon color="primary">
                                    mdi-label-outline
                                </v-icon>
                                圖卡名稱
                                <span style="color: red; font-size: 12px; margin-left: 10px;">
                                    *必填
                                </span>							
                            </label>
                            <v-text-field
                                :error-messages="error_message.name"
                                v-model="setting_name" class="ma-0 pa-0"
                                outlined
                                dense
                                placeholder="例如: 雙11活動推廣圖卡"
                                @input="onBlur('setting_name', setting_name)"
                                id="setting_name"
                            >
                            </v-text-field>					
                        </section>							
                    </div>
                    <div 
                        class="input-container"
                    >
                        <section id="preview_url">
                            <label class="mb-2"> 
                                <v-icon color="primary">
                                    mdi-earth
                                </v-icon>	
                                    預覽連結
                                <span style="color: red; font-size: 12px; margin-left: 10px;">
                                    *必填
                                </span>
                                <!-- <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon
                                                right
                                                class="orange--text"
                                                style="font-size: 14px; cursor: pointer;"
                                                v-bind='attrs'
                                                v-on='on'
                                            >
                                                mdi-help-circle-outline
                                            </v-icon>
                                        </template>
                                        <span>{{`* 建議填寫，否則無法預覽行銷圖卡\n若有設定預設值會直接帶入。`}}</span>
                                </v-tooltip> -->
                            </label>
                            
                            <v-text-field
                                :error-messages="error_message.url"
                                class="ma-0 pa-0"
                                outlined
                                dense
                                v-model="preview_url"
                                @input="onBlur('preview_url', preview_url)"
                            >
                            </v-text-field>
                        </section>							
                    </div>
                    <div 
                        class="input-container mb-0" 					
                    >
                        <section id="activate_coupon">
                            <label>
                                <v-icon>
                                    mdi-wallet-giftcard
                                </v-icon>
                                    圖卡代碼
                                <span style="color: red; font-size: 12px; margin-left: 10px;">
                                    *必填
                                </span>
                                <!-- <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            right
                                            class="orange--text"
                                            style="font-size: 14px; cursor: pointer;"
                                            v-bind='attrs'
                                            v-on='on'
                                        >
                                            mdi-help-circle-outline
                                        </v-icon>
                                    </template>
                                    <span>{{`*必填\n若有設定預設值會直接帶入。`}}</span>
                                </v-tooltip>  -->

                                <!-- 自動帶入說明dialog -->
                                <!-- <AutoCouponIntroDialog>	
                                </AutoCouponIntroDialog> -->
                                <!-- {{loggedInfo}} -->
                                <!-- <AutoGenerateUrl 
                                    v-if="preview_url !== '' && auth_mapper.SalesCardAutoCoupon"
                                    :baseUrl="preview_url"
                                    :marketingCard="activate_coupon"
                                >
                                </AutoGenerateUrl> -->

                            </label>
                            
                            <v-text-field
                                class="ma-0 pa-0"
                                outlined
                                dense
                                :error-messages="error_message.coupon"
                                v-model="activate_coupon"
                                @input="onBlur('activate_coupon', activate_coupon)"
                                placeholder="例如：card1" 
                            >
                            </v-text-field>
                        </section>			
                    </div>

                    <div class="input-container">
                        <section >
                            <label id="start_at">
                                <v-icon color="primary">
                                    mdi-calendar-today-outline
                                </v-icon>								
                                        開始時間
                                <span style="color: red; font-size: 12px; margin-left: 10px;">
                                    *必填
                                </span>
                            </label>
                            <date-picker
                                :shortcuts="$utils.date_picker_shorcuts"
                                class="app-date-picker"
                                :class="{
                                    'error-message': error_message.start_at
                                }"
                                @change="sameTimeLine(is_same_time)" 
                                v-model="start_at" 
                                type="datetime"
                                @input="onBlur('start_at', start_at)"
                            >        
                            </date-picker>
                            <span v-if="error_message.start_at"
                                class="pl-3"
                                style="color: red;font-size:12px;"
                            >
                                {{error_message.start_at}}
                            </span>
                        </section>
                        <section >
                            <label id="end_at">
                                <v-icon color="primary">
                                    mdi-calendar-today-outline
                                </v-icon>								
                                    結束時間
                                <span style="color: red; font-size: 12px; margin-left: 10px;">
                                    *必填
                                </span>
                            </label>
                            <date-picker
                                :shortcuts="$utils.date_picker_shorcuts"
                                class="app-date-picker"
                                :class="{
                                    'error-message': error_message.end_at
                                }"
                                @change="sameTimeLine(is_same_time)" 
                                v-model="end_at" 
                                type="datetime"
                                @input="onBlur('end_at', end_at)"
                            >		
                            </date-picker>	
                            <span v-if="error_message.end_at"
                                class="pl-3"
                                style="color: red;font-size:12px;"
                            >
                                {{error_message.end_at}}
                            </span>				
                        </section>				
                    </div>
                    <div
                        
                        class="d-flex mr-3 mt-2 mb-0 pb-0"
                        v-if="error_message.duplicate !== ''"
                    >
                        <!-- <i 
                            class="material-icons-outlined"
                        >
                            error
                        </i>	 -->
                        <v-icon left color="red">
                            mdi-alert-circle
                        </v-icon>
                        <div v-html="error_message.duplicate">
                        </div>					
                    </div>

                    <div
                        v-else
                        class="mr-3 mt-2 mb-4 pb-0 d-flex flex-column "
                    >
                        <!-- <i 
                            class="material-icons-outlined"
                        >
                            error
                        </i>	 -->
                        <template v-if="!is_checking">
                            <div class="d-flex">
                                <v-icon 
                                    left color="success"
                                    
                                >
                                    mdi-check-circle
                                </v-icon>
                                <div color="success">檢查通過</div>
                            </div>
	
                        </template>
                        <template v-else>
                            <div class="d-flex">
                                <v-icon 
                                    left color="orange"
                                >
                                    mdi-magnify-expand
                                </v-icon>
                                <div>檢查中</div>
                            </div>
                            <div class="mt-3">
                                <v-progress-linear
                                    indeterminate
                                    color="orange"
                                    class="mb-0"
                                ></v-progress-linear>
                            </div>

                        </template>
                    </div>

                    <div 
                        class="input-container mb-4" 					
                    >
                        <section
                        >
                            <label
                                :class="{
                                    'grey--text': !auth_mapper.SalesCardAutoCoupon
                                }"
                            >
                                <v-icon 
                                    color="primary"
                                >
                                    mdi-import
                                </v-icon>
                                
                                自動帶入折扣/推薦碼					
                            </label>

                            <v-select
                                :items="auto_coupon_items"
                                dense
                                hide-details
                                outlined
                                v-model="auto_coupon"
                                @input="onBlur('auto_coupon', auto_coupon)"
                                :disabled="!auth_mapper.SalesCardAutoCoupon"
                            >
                            </v-select>	
                            
                            <div 
                                class="mt-2"
                                v-if="!auth_mapper.SalesCardAutoCoupon"
                            > 
                                <v-icon 
                                    color="grey"
                                    class="mr-2"
                                >
                                    mdi-lock
                                </v-icon>
                                
                                <span class="red--text">Business方案以上限定</span>
                            </div>

                            <div 
                                class="mt-6"
                                v-else-if="auto_coupon && auth_mapper.SalesCardAutoCoupon"
                            > 

                                <v-row>
                                    <v-col cols="12" class="py-0">
                                        <h6 class="text-subtitle-2">「優惠」代碼參數</h6>
                                        <v-text-field 
                                            outlined
                                            dense
                                            hide-details
                                            v-model="fill_coupon" 
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row class="mt-6">
                                    <v-col cols="12" class="py-0 mb-5">
                                        <h6 class="text-subtitle-2">「推薦」代碼參數</h6>

                                        <v-text-field 
                                            outlined
                                            v-model="fill_a_code" 
                                            label=""
                                            dense
                                            hide-details
                                        >
                                        </v-text-field>    
                                    </v-col>
                                </v-row>

                                <template
                                    v-if="card_url"
                                >

                                    <h6 class="text-subtitle-2">行銷圖卡 + 自動帶入優惠/推薦碼網址</h6>

                                    <a 
                                        target="_blank" 
                                    
                                    >
                                        {{ card_url }}
                                        
                                    </a>
                                    <v-btn text
                                        @click="copyResultUrl"
                                    > 
                                        <v-icon left>mdi-content-copy</v-icon> 複製
                                    </v-btn>
                                </template>

                                <!-- 需搭配<span class="red--text">上方的"網址產生器"，將代碼帶入網址中</span>使用 -->
                            </div>

                        </section>	
                    </div>

                    <!-- <v-card style="margin: 20px 0px;">
                        <v-img
                            contain
                            lazy-src="@/assets/timeline.svg"
                            max-height="250"
                            max-width="100%"
                            src="@/assets/timeline.svg"
                        >
                            <template v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                                <v-progress-circular
                                    indeterminate
                                    color="grey lighten-5"
                                ></v-progress-circular>
                            </v-row>
                            </template>
                        </v-img>
                    </v-card> -->

                </article>
                
                <article
                    class="basic-setting-container"
                    id="normal-setting"
                    style="position: relative;"
                >
                    
                    <h4
                        class="basic-setting-title"
                        v-intersect.quiet="{
                            handler: onIntersectWrapper(2),
                            options: {
                                threshold: [0, 0.5, 1.0]
                            }
                        }"
                    >
                        圖卡設定
                        <!-- <span>
                            <v-icon
                                :color="this.$vuetify.theme.themes['dark']['primary']"
                            >
                                mdi-cogs
                            </v-icon>
                        </span> -->
                        <!-- <span
                            :style="{
                                color: $vuetify.theme.themes['dark']['warning']
                            }"
                        >
                            {{ `(${currentTimeLineMode})` }}
                        </span> -->
                    </h4>

                    <!-- <v-card class="mb-4" style="position: sticky; top: 0px;">
                        <v-tabs
                            fixed-tabs
                            v-model="selected_tab"
                            :color="this.$vuetify.theme.themes['dark']['primary']"
                            class="campaign-tab"
                        >
                            <v-tab
                                v-for="(item,index) in ['活動預熱','活動進行','活動結束']"
                                :key="item"
                                :value="index"
                                
                            >      
                                {{ item }}
                            </v-tab>
                        </v-tabs>
                    </v-card> -->

                    <!--- 原始圖卡樣式設定 --->
                    <MarketingCardOriginalCardStyle
                        :oldSettingData="oldSettingData"
                        :loadOldSettingData="load_old_setting_data"
                        style="border-bottom: 1px solid rgb(221, 221, 221);"
                        :timeLineMode="newTimeLineMode"
                        @save-time-line-setting="saveCardSettingBeforeTabsChange(2)"
                    />

                    <!--- 縮小圖卡樣式設定 --->
                    <MarketingCardSettingMiniCardStyle
                        :oldSettingData="oldSettingData"
                        :loadOldSettingData="load_old_setting_data"
                        style="margin-top: 40px;"
                        :timeLineMode="newTimeLineMode"
                        @save-time-line-setting="saveCardSettingBeforeTabsChange(2)"
                    />

                    <!--- 圖卡位置設定 --->
                    <MarketingCardSettingPosition
                        :oldSettingData="oldSettingData"
                        :loadOldSettingData="load_old_setting_data"
                        style="border-bottom: 1px solid rgb(221, 221, 221);"
                        :timeLineMode="newTimeLineMode"
                        @save-time-line-setting="saveCardSettingBeforeTabsChange(2)"
                    />

                </article>


                <div id="advanced-setting" class="basic-setting-container" style="padding: 1rem">
                    <h4
                        class="basic-setting-title"
                        v-intersect.quiet="{
                            handler: onIntersectWrapper(3),
                            options: {
                                threshold: [0, 0.6, 1.0]
                            }
                        }"
                        
                    >
                        進階設定
                        <span
                            :style="{
                                color: $vuetify.theme.themes['dark']['warning']
                            }"
                        >
                            <!-- {{ `(${currentTimeLineMode})` }} -->
                        </span>
                    </h4>
                
                
                    <v-expansion-panels style="margin-bottom: 20px;">
                        
                        <v-expansion-panel class="panel">
                            <v-expansion-panel-header 
                                class="text-subtitle-1"
                                :class="{
                                    'grey--text': !auth_mapper.SalesCardCountdown
                                }" 
                                :disable-icon-rotate="!auth_mapper.SalesCardCountdown"
                                :disabled="!auth_mapper.SalesCardCountdown"
                            >
                                倒數計時器
                                <template 
                                    v-slot:actions 
                                    v-if="!auth_mapper.SalesCardCountdown"
                                >
                                    <div>
                                        <span
                                            class="red--text"
                                        >
                                            Business方案以上限定
                                        </span>
                                        <v-icon 
                                            color="grey"
                                            class="ml-3"
                                        >
                                            mdi-lock
                                        </v-icon>
                                    </div>

                                </template>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="mb-5">

                                    <h5>						
                                        啟用狀態
                                    </h5>
                                    
                                    <div>
                                        <v-select
                                            hide-details
                                            outlined
                                            v-model="isAutoCoupon"
                                            :items="timer_setting.items"
                                            dense
                                            @change="displayTimer(isAutoCoupon)"
                                        >
                                        </v-select>
                                    </div>
                                    <!-- <v-checkbox
                                        v-model="isAutoCoupon"
                                        label="顯示"
                                        color="success"
                                        @click="oldSettingData !== null ? changeStatus('old_setting_data','is_countdown', isAutoCoupon) : changeStatus('marketing_card','is_auto_coupon', isAutoCoupon)"
                                        ref="displayTimeCountDown"
                                        id="display"
                                        @change="syncCardSetting('is_countdown', isAutoCoupon)"
                                    ></v-checkbox> -->
                                </div>

                                <div v-if="isAutoCoupon">
                                    <div class="mb-5">
                                        <label>
                                            結束時間後每幾天循環一次:
                                        </label>
                                        <v-text-field
                                            type="number"
                                            hide-details 
                                            class="ma-0 pa-0" solo
                                            v-model="repeat_day"
                                            @input="syncCardSetting('repeat_day', repeat_day)"
                                        >
                                        </v-text-field>		
                                    </div>

                                    <template v-if="end_at">
                                        <div class="mb-5" v-if="repeat_day != 0">
                                            <div>{{$utils.displayISOString(end_at)}}後，<span style="color:red;">持續顯示</span>圖卡，每<span style="color:red;">{{repeat_day}}</span>天為1個循環倒數</div>
                                        </div>
                                        <div class="mb-5" v-else>
                                            <div>{{$utils.displayISOString(end_at)}}後，<span style="color:red;">不會持續</span>顯示圖卡</div>
                                        </div>
                                    </template>

                                    <!--- 倒數計時器設定 --->
                                    <MarketingCardSettingTimeCountDown
                                        :oldSettingData="oldSettingData"
                                        :loadOldSettingData="load_old_setting_data"
                                        v-if="isAutoCoupon"
                                        :timeLineMode="newTimeLineMode"
                                        @save-time-line-setting="saveCardSettingBeforeTabsChange(2)"
                                    />

                                    <h5>桌機縮小倒數計時器設定</h5>
                                    <div class="mb-5">
                                        <section class="d-flex flex-column">
                                            <label>開頭文字</label>
                                            <v-text-field
                                                @change="changeStatus('marketing_card','desktop_mini_card_count_down_text', desktop_mini_card_count_down_text)"
                                                v-model="desktop_mini_card_count_down_text"
                                                @input="changeStatus('marketing_card','desktop_mini_card_count_down_text', desktop_mini_card_count_down_text)"
                                                hide-details class="ma-0 pa-0" solo
                                            >
                                            </v-text-field>
                                        </section>						
                                    </div>
                                    <div class="mb-5">
                                        <section class="d-flex flex-column">
                                            <label>開頭文字顏色</label>
                                            <v-text-field
                                                @change="changeStatus( 'marketing_card','desktop_mini_card_count_down_text_color', desktop_mini_card_count_down_text_color)"
                                                v-model="desktop_mini_card_count_down_text_color" hide-details class="ma-0 pa-0" solo
                                                @input="changeStatus( 'marketing_card','desktop_mini_card_count_down_text_color', desktop_mini_card_count_down_text_color)"
                                            >
                                                <template v-slot:append>
                                                    <ColorPicker
                                                        :colorMenu="desktop_mini_card_count_down_text_color_menu"
                                                        :colorValue="desktop_mini_card_count_down_text_color"
                                                        @updateColorValue="desktop_mini_card_count_down_text_color = $event"
                                                        @updateColorMenu="desktop_mini_card_count_down_text_color_menu = $event"
                                                        @changeStatusColorValue="changeStatus( 'marketing_card','desktop_mini_card_count_down_text_color', desktop_mini_card_count_down_text_color)"
                                                    />
                                                </template>    
                                            </v-text-field>
                                        </section>	
                                    </div>
                                    <div class="mb-5">
                                        <section class="d-flex flex-column">
                                            <label>結尾文字</label>
                                            <v-text-field
                                                @change="changeStatus('marketing_card','desktop_mini_card_count_down_text_end', desktop_mini_card_count_down_text_end)"
                                                v-model="desktop_mini_card_count_down_text_end"
                                                @input="changeStatus('marketing_card','desktop_mini_card_count_down_text_end', desktop_mini_card_count_down_text_end)"
                                                hide-details class="ma-0 pa-0" solo
                                            >
                                            </v-text-field>
                                        </section>						
                                    </div>	
                                    <div class="mb-5">
                                        <section class="d-flex flex-column">
                                            <label>結尾文字顏色</label>
                                            <v-text-field
                                                @change="changeStatus( 'marketing_card','desktop_mini_card_count_down_text_end_color', desktop_mini_card_count_down_text_end_color)"
                                                v-model="desktop_mini_card_count_down_text_end_color" hide-details class="ma-0 pa-0" solo
                                                @input="changeStatus( 'marketing_card','desktop_mini_card_count_down_text_end_color', desktop_mini_card_count_down_text_end_color)"
                                            >
                                                <template v-slot:append>
                                                    <ColorPicker
                                                        :colorMenu="desktop_mini_card_count_down_text_end_color_menu"
                                                        :colorValue="desktop_mini_card_count_down_text_end_color"
                                                        @updateColorValue="desktop_mini_card_count_down_text_end_color = $event"
                                                        @updateColorMenu="desktop_mini_card_count_down_text_end_color_menu = $event"
                                                        @changeStatusColorValue="changeStatus( 'marketing_card','desktop_mini_card_count_down_text_end_color', desktop_mini_card_count_down_text_end_color)"
                                                    />
                                                </template>    
                                            </v-text-field>
                                        </section>
                                    </div>

                                    <h5>手機縮小倒數計時器設定</h5>
                                    <div class="mb-5">
                                        <section class="d-flex flex-column">
                                            <label>開頭文字</label>
                                            <v-text-field
                                                @change="changeStatus('marketing_card','mobile_mini_card_count_down_text', mobile_mini_card_count_down_text)"
                                                v-model="mobile_mini_card_count_down_text"
                                                @input="changeStatus('marketing_card','mobile_mini_card_count_down_text', mobile_mini_card_count_down_text)"
                                                hide-details class="ma-0 pa-0" solo
                                            >
                                            </v-text-field>
                                        </section>						
                                    </div>
                                    <div class="mb-5">
                                        <section class="d-flex flex-column">
                                            <label>開頭文字顏色</label>
                                            <v-text-field
                                                @change="changeStatus( 'marketing_card','mobile_mini_card_count_down_text_color', mobile_mini_card_count_down_text_color)"
                                                v-model="mobile_mini_card_count_down_text_color" hide-details class="ma-0 pa-0" solo
                                                @input="changeStatus( 'marketing_card','mobile_mini_card_count_down_text_color', mobile_mini_card_count_down_text_color)"
                                            >
                                                <template v-slot:append>
                                                    <ColorPicker
                                                        :colorMenu="mobile_mini_card_count_down_text_color_menu"
                                                        :colorValue="mobile_mini_card_count_down_text_color"
                                                        @updateColorValue="mobile_mini_card_count_down_text_color = $event"
                                                        @updateColorMenu="mobile_mini_card_count_down_text_color_menu = $event"
                                                        @changeStatusColorValue="changeStatus( 'marketing_card','mobile_mini_card_count_down_text_color', mobile_mini_card_count_down_text_color)"
                                                    />
                                                </template>
                                            </v-text-field>
                                        </section>	
                                    </div>
                                    <div class="mb-5">
                                        <section class="d-flex flex-column">
                                            <label>結尾文字</label>
                                            <v-text-field
                                                @change="changeStatus('marketing_card','mobile_mini_card_count_down_text_end', mobile_mini_card_count_down_text_end)"
                                                v-model="mobile_mini_card_count_down_text_end"
                                                @input="changeStatus('marketing_card','mobile_mini_card_count_down_text_end', mobile_mini_card_count_down_text_end)"
                                                hide-details class="ma-0 pa-0" solo
                                            >
                                            </v-text-field>
                                        </section>						
                                    </div>	
                                    <div class="mb-5">
                                        <section class="d-flex flex-column">
                                            <label>結尾文字顏色</label>
                                            <v-text-field
                                                @change="changeStatus( 'marketing_card','mobile_mini_card_count_down_text_end_color', mobile_mini_card_count_down_text_end_color)"
                                                v-model="mobile_mini_card_count_down_text_end_color" hide-details class="ma-0 pa-0" solo
                                                @input="changeStatus( 'marketing_card','mobile_mini_card_count_down_text_end_color', mobile_mini_card_count_down_text_end_color)"
                                            >
                                                <template v-slot:append>
                                                    <ColorPicker
                                                        :colorMenu="mobile_mini_card_count_down_text_end_color_menu"
                                                        :colorValue="mobile_mini_card_count_down_text_end_color"
                                                        @updateColorValue="mobile_mini_card_count_down_text_end_color = $event"
                                                        @updateColorMenu="mobile_mini_card_count_down_text_end_color_menu = $event"
                                                        @changeStatusColorValue="changeStatus( 'marketing_card','mobile_mini_card_count_down_text_end_color', mobile_mini_card_count_down_text_end_color)"
                                                    />
                                                </template>    
                                            </v-text-field>
                                        </section>	
                                    </div> 
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel class="panel">
                            <v-expansion-panel-header 
                                class="text-subtitle-1" 
                                :class="{
                                    'grey--text': !auth_mapper.SalesCardProductMode
                                }" 
                                :disable-icon-rotate="!auth_mapper.SalesCardProductMode"
                                :disabled="!auth_mapper.SalesCardProductMode"
                            >
                                商品頁價格修改
                                <template 
                                    v-slot:actions 
                                    v-if="!auth_mapper.SalesCardProductMode"
                                >
                                    <div>
                                        <span
                                            class="red--text"
                                        >
                                            Business方案以上限定
                                        </span>
                                        <v-icon 
                                            color="grey"
                                            class="ml-3"
                                        >
                                            mdi-lock
                                        </v-icon>
                                    </div>

                                </template>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <!--- 商品資訊設定 --->
                                <MarketingCardSettingProductInfo
                                    :oldSettingData="oldSettingData"
                                    :loadOldSettingData="load_old_setting_data"
                                    :timeLineMode="newTimeLineMode"
                                    @save-time-line-setting="saveCardSettingBeforeTabsChange(2)"
                                />
                            </v-expansion-panel-content>
                        </v-expansion-panel>                        
                    </v-expansion-panels>
                </div>    

            </div>
                
        </div>
        <v-row justify="center">
            <v-dialog
                @click:outside="closePreview"
                v-model="preview_dialog.is_show"
                max-width="390"
            >
            <v-card>
                <v-card-title 
                    class="text-h5 primary"
                    style="color: #FFFFFF;"
                >
                    {{preview_dialog.title}}
                </v-card-title>
                <v-card-text class="mt-4">
                    {{preview_dialog.text}}
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="grey darken-1"
                    text
                    @click="closePreview"
                >
                    停留在此頁
                </v-btn>
                <v-btn
                    color="primary darken-1"
                    text
                    @click="goPreview"
                >
                    前往查看
                    <v-icon small>
                        mdi-open-in-new
                    </v-icon>
                </v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
        </v-row>
        <v-dialog
            v-model="save_load_dialog"
            hide-overlay
            persistent
            width="300"
        >
            <v-card
                color="primary"
                dark
            >
                <v-card-text class="pt-4">
                    保存圖卡中
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-card>    

</template>

<script>

import {
  apiGetContainers 
} from '@/api/optimize.js'

import {
    apiCreateCard,
    apiUpdateCard,
    apiCardGetByWithData,
    apiCardGetByTagsWithData,
    apiReleaseCard,
 } from "@/api/sales-card.js";

import {
    apiGetOrganizeFunctionStatus
} from '@/api/organize.js'

import { mapState, mapGetters } from 'vuex';

// DatePicker!
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/zh-tw'

// impoort 子元件
import MarketingCardCategories from "./MarketingCardSettingBasicComponents/MarketingCardCategories.vue";
import MarketingCardSettingProductInfo from "./MarketingCardSettingProductInfo.vue";
import MarketingCardSettingTimeCountDown from "./MarketingCardSettingTimeCountDown.vue";
import MarketingCardSettingPosition from "./MarketingCardSettingPosition.vue";
import MarketingCardOriginalCardStyle from "./MarketingCardOriginalCardStyle.vue";
import MarketingCardSettingMiniCardStyle from "./MarketingCardSettingMiniCardStyle.vue";
import ColorPicker from "@/components/Utils/ColorPicker.vue"


// 引入自動帶入功能說明視窗
// import AutoCouponIntroDialog from '../MarketingCardDialogs/AutoCouponIntroDialog.vue'
// import AutoGenerateUrl from '../MarketingCardDialogs/AutoGenerateUrl.vue'


export default {
    props: {
        card_data: Object,
        cardInnerHTML: String,
        miniCardInnerhtml: String,
        desktopMiniCardInnerHTML: String,
        modeCardSetting: Object,
        oldTimeLineMode: String,
        newTimeLineMode: String,
        saveMarketingCardSetting: Boolean,
        currentTimeLineMode: String
    },
    name: "MarketingCardSetting",
    components: {
        DatePicker,
        MarketingCardCategories,
        // AutoCouponIntroDialog,
        // AutoGenerateUrl,
        MarketingCardSettingProductInfo,
        MarketingCardSettingTimeCountDown,
        MarketingCardSettingPosition,
        MarketingCardOriginalCardStyle,
        MarketingCardSettingMiniCardStyle,
        ColorPicker
    },
    data() {
        return{

            category_setting: {
                is_show: false,
                row: 0,
                default_city: '',
                default_district: '',
            },

            is_same_time: true,

            selected_tab: 0,

            /* 圖卡設定檔名稱 */
      	    setting_name: '',
            
            /* 圖卡預覽網址 */
      	    preview_url: '',

            auto_coupon: 0,

            /* 圖卡作用網域 */
            activate_domain: '',

            /* 圖卡作用優惠代碼 */
            activate_coupon: '',

            /* 開始時間 */
            start_at: "",

            /* 結束時間 */
            end_at: "",

            // 活動開始時間
            campaign_start_at: "",

            // 活動結束時間
            campaign_end_at: "",

            /* activate_domain 和 activate_coupon 檢查錯誤訊息 */
            is_checking: false,
            error_message: {
                name: '',
                url: '',
                start_at: '',
                end_at: '',
                coupon: '',
                duplicate: '',
            },

            /* 是否自動帶入優惠代碼 */
      	    isAutoCoupon: false,

            countdown_method: {
                text: '圖卡開始/結束時間',
                value: 'default',
                hint: "圖卡結束時間 減去 圖卡開始時間進行倒數"
            },

            // 重複輪迴日
		    repeat_day: 0,

            /* 倒數計時說明文字 */
            count_down_text: "限時倒數",
            count_down_text_bg_color: "#ffb3be",
            count_down_text_color: "#ff0f0f",

            row: 0,

            selectedCity: null,
            selectedDistrict: null,

            marketing_card_setting: null,

            container_name: "",
            container_items: null,
            container_name_items: null,
            container_id: '',

            load_old_setting_data: false,

            time_line_mode: '活動預熱',

            /* 桌機縮小圖卡設定 */
            desktop_mini_card_text: '桌機縮小的行銷文字',
            desktop_mini_card_color:'#FFFFFF',
            desktop_mini_card_bg_color:'#ffb3be',
            desktop_mini_card_align: 'center',
            desktop_mini_card_opacity: '',      	

            /* 手機縮小圖卡設定 */
            mini_card_text: '手機縮小的行銷文字',
            mini_card_color:'#FFFFFF',
            mini_card_bg_color:'#ffb3be',
            mini_card_align: 'center',
            mini_card_opacity: '',

            /*  */
            mobile_mini_card_count_down_text: "▼",
            mobile_mini_card_count_down_text_color: "#000",
            mobile_mini_card_count_down_text_end: "▼",
            mobile_mini_card_count_down_text_end_color: "#000",      	
            desktop_mini_card_count_down_text: "▶",
            desktop_mini_card_count_down_text_color: "#000",
            desktop_mini_card_count_down_text_end: "▶",
            desktop_mini_card_count_down_text_end_color: "#000",

        
            mini_card_bg_color_menu: false,
            mobile_mini_card_count_down_text_color_menu: false,
            mobile_mini_card_count_down_text_end_color_menu: false,
            desktop_mini_card_color_menu: false,
            desktop_mini_card_bg_color_menu: false,
            desktop_mini_card_count_down_text_color_menu: false,
            desktop_mini_card_count_down_text_end_color_menu: false,
            mini_card_color_menu: false,

            parseKey: {
                "活動預熱" : 'warmUpCardSetting',
                "活動進行" : 'activityCardSetting',
                "活動結束" : 'endUpCardSetting'
            },
            oldSettingData: null,

            timer_setting: {
                mode_items: [
                    {
                        text: '圖卡開始/結束時間',
                        value: 'default',
                        hint: "圖卡結束時間 減去 圖卡開始時間進行倒數"
                    },
                    {
                        text: '以天循環',
                        value: 'day',
                        hint: "在圖卡開始顯示後，依照設定的天數持續循環，直到圖卡結束時間"
                    }
                ],
                items: [
                    {
                        text: '啟用',
                        value: true,
                    },
                    {
                        text: '關閉',
                        value: false,
                    }
                ]
            },
            auto_coupon_items: [
                {
                    text: '啟用',
                    value: 1,
                },
                {
                    text: '關閉',
                    value: 0,
                }
            ],
            save_load_dialog: false,
            preview_dialog: {
                text: '',
                title: '',
                is_show: false,
                result: null
            },
            auth_mapper: {},
            fill_coupon: '',
            fill_a_code: '',

        }
    },
    async created() {
        await this.init()
        await this.checkAuth()
        if (this.auth_mapper['SalesCardAutoCoupon']) {
            this.auto_coupon = 1
        }
        else {
            this.auto_coupon = 0
        }
    },
    destroyed() {
        this.$store.commit('old_setting_data', null)
        this.$store.commit('warm_up_card_setting', null)
        this.$store.commit('activity_card_setting', null)
        this.$store.commit('end_up_card_setting', null)
    },
    computed: {
        ...mapState( ['is_auto_coupon','marketing_card'] ),
        ...mapGetters(['warmUpCardSetting','activityCardSetting','endUpCardSetting','marketing_card', 'loggedInfo']),
        checkDisplayMarketingCardTimeNotNull() {
            return !(this.start_at && this.end_at)
        },
        card_url: function(){
            return this.updateUrl()
        },
    },
    methods: {
        async init(){
            console.log('setting_card_data:',this.card_data)
            this.oldSettingData = JSON.parse(JSON.stringify(this.card_data))
            console.log('this.oldSettingData',this.oldSettingData);
            console.log('add_column:', this.oldSettingData.add_column)

            // 圖卡種類
            if (this.oldSettingData['tags'] !== '') {
                let area_string = this.oldSettingData['tags'].split(',')
                let district = area_string[0] 
                let city = area_string[1]
                this.category_setting.default_city = city 
                this.category_setting.default_district = district
                this.category_setting.row = 1
                this.row = 1
                
            }
            else {
                this.row = 0
                this.category_setting.row = 0
            }
            this.category_setting.is_show = true

            console.log(this.oldTimeLineMode)
            console.log(this.newTimeLineMode)
            // console.log(this.loggedInfo?.['default_value']?.['containersValue']?.[this.selectedContainer?.['name']]?.['coupon_id']);
            
            // 如果User有設定預設值，依照目前選擇的container去loggedInfo比對取得設定的預設值
            // this.activate_coupon = this.loggedInfo?.['default_value']?.['containersValue']?.[this.selectedContainer?.['name']]?.['coupon_id'] || ""
            // this.activate_coupon !== "" && this.onBlur('activate_coupon', this.activate_coupon)
            // this.preview_url = this.loggedInfo?.['default_value']?.['containersValue']?.[this.selectedContainer?.['name']]?.['preview_url'] || ""
            // this.preview_url !== "" && this.onBlur('preview_url', this.preview_url)
            // let img_src = this.loggedInfo?.['default_value']?.['containersValue']?.[this.selectedContainer?.['name']]?.['card_image'] || ""
            // img_src !== "" && this.changeStatus('marketing_card','img_url', img_src)
            if (this.oldSettingData !== null) {
                
                console.log("載入舊的設定檔")
                console.log(this.oldSettingData);
                let add_column = ""
                try {
                    add_column = JSON.parse(this.oldSettingData.add_column)
                } catch (error) {
                    console.log('no_add_column', error)
                }
                
                console.log('add_column_2',add_column)
                let warm_up_setting = add_column.warm_up_setting
                let activity_card_setting = add_column.activity_card_setting
                let end_up_setting = add_column.end_up_setting
                if (warm_up_setting) {
                    warm_up_setting['coupon_id'] = this.oldSettingData.coupon_id
                    warm_up_setting['preview_url'] = this.oldSettingData.preview_url
                }
                if (activity_card_setting) {
                    activity_card_setting['coupon_id'] = this.oldSettingData.coupon_id
                    activity_card_setting['preview_url'] = this.oldSettingData.preview_url
                }
                if (end_up_setting) {
                    end_up_setting['coupon_id'] = this.oldSettingData.coupon_id
                    end_up_setting['preview_url'] = this.oldSettingData.preview_url
                }
                
                // if (add_column.warm_up_setting) {
                //     this.isAutoCoupon = JSON.parse(this.oldSettingData.add_column).warm_up_setting.is_countdown
                // }
                console.log('this.oldSettingData.auto_coupon', this.oldSettingData.auto_coupon)
                this.changeStatus('marketing_card','is_auto_coupon', this.oldSettingData.is_countdown)
                this.changeStatus('marketing_card','auto_coupon', this.oldSettingData.auto_coupon)
                if (add_column && add_column.product_mode !== 0) {
                    this.changeStatus('marketing_card','product_mode', add_column.product_mode)
                    this.changeStatus('marketing_card','discount_price_color', add_column.discount_price_color)
                    this.changeStatus('marketing_card','discount_price', add_column.discount_price)
                    this.changeStatus('marketing_card','discount_price_size', add_column.discount_price_size)
                    this.changeStatus('marketing_card','product_text_size', add_column.product_text_size)
                    this.changeStatus('marketing_card','product_text_color', add_column.product_text_color)
                    this.changeStatus('marketing_card','product_text', add_column.product_text)

                }

                if (add_column && add_column.fill_coupon) {
                    this.fill_coupon = add_column.fill_coupon
                }

                if (add_column && add_column.fill_a_code) {
                    this.fill_a_code = add_column.fill_a_code
                }

                await this.$store.commit('warm_up_card_setting', warm_up_setting)
                await this.$store.commit('activity_card_setting', activity_card_setting )
                await this.$store.commit('end_up_card_setting', end_up_setting )
                await this.$store.commit('old_setting_data', null)
                this.readCardSettingAfterTabsChange()

                this.mobile_mini_card_count_down_text = this.marketing_card.mobile_mini_card_count_down_text
                this.mobile_mini_card_count_down_text_color = this.marketing_card.mobile_mini_card_count_down_text_color
                this.mobile_mini_card_count_down_text_end = this.marketing_card.mobile_mini_card_count_down_text_end
                this.mobile_mini_card_count_down_text_end_color = this.marketing_card.mobile_mini_card_count_down_text_end_color 

                this.desktop_mini_card_count_down_text = this.marketing_card.desktop_mini_card_count_down_text 
                this.desktop_mini_card_count_down_text_color = this.marketing_card.desktop_mini_card_count_down_text_color
                this.desktop_mini_card_count_down_text_end = this.marketing_card.desktop_mini_card_count_down_text_end
                this.desktop_mini_card_count_down_text_end_color = this.marketing_card.desktop_mini_card_count_down_text_end_color
            }
        },
        async sameTimeLine(val) {
            console.log('片美美美',val);
            console.log(this.start_at);
            console.log(this.end_at);

            // 用這個count解每次點第一次同圖卡開始、結束時間都會沒有的bug，這方法很爛，但暫時真的找不到解法
            let count = 0
            while( count < 2 ) {
                if (this.is_same_time) {
                    this.campaign_start_at = await this.start_at
                    console.log(this.campaign_start_at);
                    this.campaign_end_at = await this.end_at
                    console.log(this.campaign_end_at);
                    await this.onBlur('campaign_start_at', this.campaign_start_at)
                    await this.onBlur('campaign_end_at', this.campaign_end_at)

                    // new Date(this.start_at).toString() !== "Invalid Date" ? await this.onBlur('campaign_start_at', this.campaign_start_at) : this.start_at
                    // new Date(this.end_at).toString() !== "Invalid Date" ? await this.onBlur('campaign_end_at', this.campaign_end_at) : this.end_at
                    await this.$emit('same-time-line-hint', true)
                    count++
                } else {
                    this.campaign_start_at = ""
                    this.onBlur('campaign_start_at', this.campaign_start_at)
                    this.campaign_end_at = ""
                    this.onBlur('campaign_end_at', this.campaign_end_at)
                    this.$emit('same-time-line-hint', false)
                    count++
                }
            } 
            
        },
        onIntersectWrapper(step) {
            return (entries) => {
                // 現在這裡的 'step' 是你傳入的參數
                // console.log("step",step);
                // console.log(entries);
                // console.log(observer);
                // console.log(entries[0].intersectionRatio);
                
                // if (entries[0].intersectionRect.top < 25) {
                //     step = 1;
                // }
                
                this.isIntersecting = entries[0].intersectionRatio >= 0.4

                this.$emit('get-step', step)
            }
        },
        async saveCardSettingBeforeTabsChange(mode) {
            // mode = 1 代表是切換tab要把舊的值存起來，所以要用this.oldTimeLineMode
            // mode = 2 代表是儲存當下的區間，那就是要存this.newTimeLineMode
            
            console.log(this.oldTimeLineMode);
            
            // console.log(this.cardInnerHTML);
            console.log(this.marketing_card_setting);

            // 一開始點新增進來會undefined就直接return
            // if (this.oldTimeLineMode === undefined) return

            if (mode == 1) {
                console.log("!!!!!!!!!!!!!")
                // console.log(JSON.parse(this[this.parseKey[this.oldTimeLineMode]]['add_column']))

                // copy過去，如果在新增圖卡檔案的模式下，於某個區間沒有去設定價格蓋台模式，會去儲存到上一個tab的價格蓋台模式設定，所以要把它蓋回去再存，以免出bug
                this.marketing_card_setting = { ...JSON.parse(this[this.parseKey[this.oldTimeLineMode]]['add_column']) }
                
            }

            let params = await {
                "is_countdown": this.isAutoCoupon,
                "tags": this.row == 0 ? "" : this.selectedDistrict + ',' + this.selectedCity,
                "setting_name": this.setting_name,
                "card_content": JSON.parse(JSON.stringify(this.cardInnerHTML)),
                "coupon_id": this.activate_coupon,
                "preview_url": this.preview_url,
                "start_at": this.parseDateFormat(this.start_at),
                "campaign_start_at": this.campaign_start_at !== '' && this.campaign_start_at !== null ? this.parseDateFormat(this.campaign_start_at) : "",
                "end_at": this.parseDateFormat(this.end_at),
                "campaign_end_at": this.campaign_end_at !== '' && this.campaign_end_at !== null ? this.parseDateFormat(this.campaign_end_at) : "",
                "repeat_day": Number(this.repeat_day),
                "card_hint": JSON.parse(JSON.stringify(this.miniCardInnerhtml)),
                "desktop_card_hint": JSON.parse(JSON.stringify(this.desktopMiniCardInnerHTML)),
                "mobile_card_margin": this.marketing_card.card_mobile_mg_top + 'px 0px 0px 0px',
                "mobile_card_padding": '0px 5px',
                "mobile_mini_card_margin": this.marketing_card.card_mobile_mini_mg_top + 'px 0px 0px 0px',
                "mobile_mini_card_padding": '0px 0px 0px 0px',
                "desktop_card_margin": '0px' + ' ' + this.marketing_card.card_desktop_mg_right + 'px' + ' ' + this.marketing_card_setting.card_desktop_mg_bottom + 'px' + ' ' + '0px',
                "container_id": this.$route.params.container_id,
                "add_column": JSON.stringify({
					"product_mode": this.marketing_card_setting.product_mode,
					"timer_off_text": this.marketing_card_setting.timer_off_text,
					"timer_off_text_color": this.marketing_card_setting.timer_off_text_color,
					"discount_price": this.marketing_card_setting.discount_price,
					"discount_price_size": this.marketing_card_setting.discount_price_size,
					"discount_price_color": this.marketing_card_setting.discount_price_color,
					"product_text": this.marketing_card_setting.product_text,
					"product_text_color": this.marketing_card_setting.product_text_color,
					"product_text_size": this.marketing_card_setting.product_text_size,
				})
            }
            console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~", params);
            let text = ''
            switch (mode === 1 ? this.oldTimeLineMode : this.newTimeLineMode) {
                case "活動預熱":
                    text = 'update_warm_up_card_setting'
                    
                    break;
                case "活動進行":
                    text = 'update_activity_card_setting'
                    // await this.$store.commit('activity_card_setting', "fknskfdnk")
                    break;
                case "活動結束":
                    text = 'update_end_up_card_setting'
                    // await this.$store.commit('end_up_card_setting', "fknskfdnk")
                    break;
                default:
                    break;
            }
            
            console.log(text)

            await this.$store.commit(text, params)

            console.log('_____________1_________________')
            // console.log(this.$store.getters.)
            console.log('_____________1_________________')
        },
        async loadOldSettingData() {
            // this.changeStatus('marketing_card','get_ele_innerHTML', true)
            let params = this.$route.query;
			console.log("380行",params);

            // if (params.setting_id === undefined && this.oldSettingData !== null) {
    		// 	return
    		// }

            if (params.copy_mode !== undefined && params.copy_mode === 'off') {
				console.log("非複製模式～");
    			// this.setting_id = params.setting_id
    		} else {
				console.log("複製模式～");
    			// this.setting_id = ''
    		}

            if (this.oldSettingData !== null) {
                console.log("1");
                this.row = this.oldSettingData.tags === "" ? 0 : 1
                console.log(this.row);
                this.marketing_card.row = this.oldSettingData.tags === "" ? 0 : 1
                console.log(this.marketing_card)
                this.setting_name = this.oldSettingData.setting_name
                this.marketing_card.setting_name = this.oldSettingData.setting_name
                this.preview_url = this.oldSettingData.preview_url       
                this.marketing_card.preview_url = this.oldSettingData.preview_url       
                this.activate_coupon = this.oldSettingData.coupon_id
                this.auto_coupon = this.oldSettingData.auto_coupon

                this.marketing_card.activate_coupon = this.oldSettingData.coupon_id
                this.start_at = new Date(this.oldSettingData.start_at)
                this.marketing_card.start_at = new Date(this.oldSettingData.start_at)
                this.end_at = new Date(this.oldSettingData.end_at)
                this.marketing_card.end_at = new Date(this.oldSettingData.end_at)
                this.campaign_start_at = new Date(this.oldSettingData.campaign_start_at)
                this.marketing_card.campaign_start_at = new Date(this.oldSettingData.campaign_start_at)
                this.campaign_end_at = new Date(this.oldSettingData.campaign_end_at)
                this.marketing_card.campaign_end_at = new Date(this.oldSettingData.campaign_end_at)
                this.repeat_day = this.oldSettingData.repeat_day
                this.marketing_card.repeat_day = this.oldSettingData.repeat_day
                this.isAutoCoupon = this.oldSettingData.is_countdown
                this.marketing_card.isAutoCoupon = this.oldSettingData.is_countdown
            } else {
                console.log("2", this.marketing_card);
                console.log(this.oldTimeLineMode);
                console.log(this.newTimeLineMode);
                if(!this.newTimeLineMode) return
                let display_card_setting = this[this.parseKey[this.newTimeLineMode]]
                console.log(this.parseKey[this.newTimeLineMode])
                console.log('display_card_setting', display_card_setting);
                console.log(this.row);
                this.marketing_card.row = display_card_setting.tags === "" ? 0 : 1
                console.log(this.marketing_card)
                this.setting_name = display_card_setting.setting_name
                this.marketing_card.setting_name = display_card_setting.setting_name
                this.preview_url = display_card_setting.preview_url
                this.auto_coupon = display_card_setting.auto_coupon     
                this.marketing_card.preview_url = display_card_setting.preview_url       
                this.activate_coupon = display_card_setting.coupon_id
                this.marketing_card.activate_coupon = display_card_setting.coupon_id
                // this.start_at = this.$utils.parseDateFormat(display_card_setting.start_at)
                this.start_at = new Date(display_card_setting.start_at).toString() === "Invalid Date" ? "" : new Date(display_card_setting.start_at)
                console.log(this.start_at.toString());
                
                let payload = {
                    "key" : 'start_at',
                    "value" : this.$utils.parseDateFormat(display_card_setting.start_at)
                }

                this.$emit('get-time-line', payload)

                this.marketing_card.start_at = new Date(display_card_setting.start_at).toString() === "Invalid Date" ? "" : new Date(display_card_setting.start_at)
                this.end_at = new Date(display_card_setting.end_at).toString() === "Invalid Date" ? "" : new Date(display_card_setting.end_at)

                payload.key = 'end_at'
                payload.value = this.$utils.parseDateFormat(display_card_setting.end_at) 
                this.$emit('get-time-line', payload)
                // this.onBlur('end_at', display_card_setting.end_at)
                this.marketing_card.end_at = new Date(display_card_setting.end_at).toString() === "Invalid Date" ? "" : new Date(display_card_setting.end_at)
                this.campaign_start_at = new Date(display_card_setting.campaign_start_at).toString() === "Invalid Date" ? this.getSameTimeValue() : new Date(display_card_setting.campaign_start_at)
                payload.key = 'campaign_start_at'
                payload.value = display_card_setting.campaign_start_at.includes('NaN') ? '' : display_card_setting.campaign_start_at
                this.$emit('get-time-line', payload)
                // this.onBlur('campaign_start_at', display_card_setting.campaign_start_at)

                this.marketing_card.campaign_start_at = new Date(display_card_setting.campaign_start_at)
                this.campaign_end_at = new Date(display_card_setting.campaign_end_at).toString() === "Invalid Date" ? this.getSameTimeValue() : new Date(display_card_setting.campaign_end_at)
                payload.key = 'campaign_end_at'
                payload.value = display_card_setting.campaign_end_at.includes('NaN') ? '' : display_card_setting.campaign_end_at
                this.$emit('get-time-line', payload)
                // this.onBlur('campaign_end_at', display_card_setting.campaign_end_at)

                this.marketing_card.campaign_end_at = new Date(display_card_setting.campaign_end_at)
                this.repeat_day = display_card_setting.repeat_day
                this.marketing_card.repeat_day = display_card_setting.repeat_day
                this.isAutoCoupon = display_card_setting.is_countdown
                this.marketing_card.isAutoCoupon = display_card_setting.is_countdown
                this.marketing_card.card_type = this.parseKey[this.newTimeLineMode]
            }
        },
        getSameTimeValue() {
            setTimeout(() => {
                this.campaign_start_at = new Date(this[this.parseKey[this.newTimeLineMode]].campaign_start_at)
                // this.campaign_end_at = new Date(this[this.parseKey[this.newTimeLineMode]].campaign_end_at)
            }, 500);
            setTimeout(() => {
                // this.campaign_start_at = new Date(this[this.parseKey[this.newTimeLineMode]].campaign_start_at)
                this.campaign_end_at = new Date(this[this.parseKey[this.newTimeLineMode]].campaign_end_at)
            }, 800);
        },
        handleContainerId(value) {
            console.log(value);
            this.container_id = this.container_items.filter(item => {
                return item.name === value
            }).map(item => {
                return item.id
            })
            console.log(this.container_id);
        },
        changeStatus: async function(param_name, field_name, new_value){
            let tmp = JSON.parse(JSON.stringify(this.$store.getters.marketing_card)) 
            tmp[field_name] = new_value
            console.log(field_name)
            console.log(new_value)
            await this.$store.commit(param_name, tmp)
            this.saveCardSettingBeforeTabsChange(2)
            console.log('after_commit', this.$store.getters[param_name])
        },
        selected_district(value) {
            console.log('selected_district: ', value)
            this.selectedDistrict = value
        },
        selected_city(value) {
            console.log('selected_city: ', value)
            this.selectedCity = value
        },
        handleRow(int) {
            console.log(int);
            return this.row = int
        },
        /**
		 * 2021-10-15 created by Watson 
		 *
		 * 說明: 檢查網域和優惠代碼的組合是否已經存在
		 *
		 */ 	      	
    	checkSettingDataIsExist: async function(key, value) {
            let is_duplicate = false
            console.log("時間更換");
            console.log(key);
            console.log(value);
            console.log(this.start_at)
            console.log(this.activate_coupon)
            if (this.load_old_setting_data) {
                if (key === 'activate_coupon') {
                    key = "coupon_id"
                }
                // 可以動態更新old_setting_data裡面的value
                if (key !== undefined && value !== undefined) {
                    this.$store.commit('update_old_setting_data',{ [key] : value })
                }
            }

            this.changeStatus('marketing_card','start_at', this.start_at)
            this.changeStatus('marketing_card','campaign_start_at', this.campaign_start_at)
            this.changeStatus('marketing_card','end_at', this.end_at)
            this.changeStatus('marketing_card','campaign_end_at', this.campaign_end_at)
            this.changeStatus('marketing_card','activate_coupon', this.activate_coupon)
            this.changeStatus('marketing_card','setting_name', this.setting_name)
            this.changeStatus('marketing_card','preview_url', this.preview_url)

            let checks = []
            if (this.setting_name === "") {
                this.error_message.name = '圖卡名稱為必填'
                checks.push(false)
            }
            else {
                this.error_message.name = ''
            }

            if (this.setting_name && this.setting_name.length > 32) {
                this.error_message.name = '長度不可超過32字元'
                checks.push(false)
            }
            else {
                this.error_message.name = ''
            }

            if (!this.start_at || isNaN(this.start_at)) {
                this.error_message.start_at = '開始時間為必填'
                checks.push(false)
            }
            else {
                this.error_message.start_at = ''
            }

            if (!this.end_at || isNaN(this.end_at)) {
                this.error_message.end_at = '結束時間為必填'
                checks.push(false)
            }
            else {
                this.error_message.end_at = ''
            }

            if (this.activate_coupon === '')  {
                this.error_message.coupon = '圖卡代碼為必填'
                checks.push(false)
            }
            else {
                this.error_message.coupon = ''
            }

            if (this.activate_coupon && this.activate_coupon.length > 32) {
                this.error_message.coupon = '長度不可超過32字元'
                checks.push(false)
            }
            else {
                this.error_message.coupon = ''
            }

            if (this.preview_url === '') {
                this.error_message.url = '預覽網址為必填'
                checks.push(false)
            }
            else {
                this.error_message.url = ''
            }

            try {
                let url = new URL(this.preview_url)
                console.log(url)
            } catch (error) {
                this.error_message.url = '預覽網址不是有效的網址'
                checks.push(false)
            }

            if (checks.includes(false)){
                return true
            }

            let result = null
            this.is_checking = true
            if (this.row === 1) {
                result = await apiCardGetByTagsWithData(
                    this.$route.params.org_id, 
                    this.activate_coupon, 
                    this.$route.params.container_id, 
                    this.parseDateFormat(this.start_at).split(' ')[0], 
                    this.selectedDistrict + ',' + this.selectedCity,
                    this.parseDateFormat(this.end_at).split(' ')[0],
                )
            }
            else {
                result = await apiCardGetByWithData (
                    this.$route.params.org_id, 
                    this.activate_coupon, 
                    this.$route.params.container_id, 
                    this.parseDateFormat(this.start_at).split(' ')[0], 
                    this.parseDateFormat(this.end_at).split(' ')[0],
                )
            }

            console.log('duplicate_result: ',result)
            this.error_message.duplicate = ''
            is_duplicate = false 
            if (result.overlap.length <= 0) {
                is_duplicate = false
            }
            else {

                for (let idx = 0; idx < result.overlap.length; idx++) {
                    let current_setting = result.overlap[idx]
                    if (current_setting.id !== parseInt(this.$route.query.setting_id)) {
                        is_duplicate = true
                        let setting_url = `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_site/marketing_card/edit?setting_id=${current_setting.id}`
                        this.error_message.duplicate = `
                        <div>這個圖卡和 <span style="color:red;"><a href="${setting_url}" target="_blank">"${current_setting.setting_name}"</a></span> 的時間區間重疊了喔！</div>
                        <div>${this.$utils.displayISOString(current_setting.start_at)} ~ ${this.$utils.displayISOString(current_setting.end_at)}</div>
                        <div">可以調整 開始/結束時間 或是 圖卡代碼，進行修正</div>
                        `
                        break
                    }
                    
                }

            }
            this.is_checking = false
            return is_duplicate


            // await apiCardGetBy(this.selectedContainer.org_id, this.activate_coupon, this.selectedContainer.id, this.parseDateFormat(this.start_at).split(' ')[0], true)
            //     .then( async resp => {
            //         console.log(resp)
            //         if (resp.data.code !== 200) return false
            //         let message = '';
    		// 		let data = resp['data']['data'];

			// 		// do {
			// 			// 代表這個組合沒被使用過
			// 			if (data === null) {
			// 				console.log('沒被使用過的組合')
			// 				message = ''
			// 				return is_duplicate
			// 			}
			// 			console.log('檢查是否有重複的', this.selectedDistrict + ',' + this.selectedCity)
			// 			// 代表這個網域加coupon有被使用過了，檢查所有有使用過的設定中，有沒有重疊的時間區間
			// 			// 有就跳錯誤訊息
			// 			for(let idx = 0; idx < data.length; idx++) {
			// 				let setting = data[idx]

			// 				// 已存在設定檔的使用時間
			// 				let setting_start_at = new Date(setting.start_at).getTime()
			// 				let setting_end_at = new Date(setting.end_at).getTime()
            //                 let is_override_time = ( this.start_at.getTime() <= setting_end_at && this.end_at.getTime() >= setting_start_at)
            //                 console.log('is_override_time:', is_override_time)
			// 				// console.log(this.start_at.getTime() <= setting_end_at)
			// 				// console.log(this.end_at.getTime() >= setting_start_at)

            //                 // 有踩到同個時段的話
            //                 if (is_override_time) {
            //                     // 如果是一般的，不能存
            //                     if (this.row === 0) {
            //                         // 代表是更改自己
            //                         if (this.$route.query.copy_mode !== 'off') {
            //                             message = '這個圖卡設定和' + setting.setting_name +' 重疊了喔！' + '('+ new Date(setting.start_at).toLocaleString() + ' ~ ' + new Date(setting.end_at).toLocaleString() +')';
            //                         }
            //                         else {
            //                             message = ''
            //                         }
                                    
            //                     }
            //                     // 如果是區域的，只要不是相同區域，都可以存
            //                     else if(this.row === 1) {

            //                         if (this.$route.query.copy_mode !== 'off') {
            //                             let current_tags = this.selectedDistrict + ',' + this.selectedCity
            //                             if (current_tags === setting.tags || setting.tags === '') {
            //                                 message = '這個圖卡設定和' + setting.setting_name +' 重疊了喔！' + '('+ new Date(setting.start_at).toLocaleString() + ' ~ ' + new Date(setting.end_at).toLocaleString() +')';
            //                             }
            //                             else {
            //                                 message = ''
            //                             }

            //                         }
            //                         else {
            //                             message = ''
            //                         }

            //                     }
            //                 }
            //                 // 只要沒踩到同個時段，不管是哪種都可以存
            //                 else {
            //                     this.message = ''
            //                 }

			// 				if (message !== '') {
			// 					break;
			// 				}
			// 			}
						
			// 		// } while(0)

    		// 		this.message = message;
            //         if (message !== '') {
            //             is_duplicate = true 
            //         }
            //     })
            //     .catch( error => {
            //         console.log(error)
            //     })
            // console.log('is_duplicate',is_duplicate)
            // return is_duplicate
    	},
        check_all_input_has_value() {

            let result = true

            if (this.marketing_card_setting.is_auto_coupon && (this.marketing_card_setting.start_at === null || this.marketing_card_setting.start_at === "") ) {
                this.scroll_to('start_at')
                return result = false
            } else if (this.marketing_card_setting.is_auto_coupon && (this.marketing_card_setting.end_at === null || this.marketing_card_setting.end_at === "") ) {
                this.scroll_to('end_at')
                return result = false
            } else if (this.marketing_card_setting.setting_name === null || this.marketing_card_setting.setting_name === ""){
                this.scroll_to('setting_name')
                return result = false
            } else if (this.marketing_card_setting.preview_url === null || this.marketing_card_setting.preview_url === "") {
                this.scroll_to('preview_url')
                return result = false
            } else if (this.marketing_card_setting.activate_coupon === null || this.marketing_card_setting.activate_coupon === "") {
                this.scroll_to('activate_coupon')
                return result = false
            } else if(this.row === 1 && this.selectedCity === '' ) {
                return result = false
            }

            return result
        },
        /**
         * @description 通過指定的元素 id 平滑滾動至該元素位置。
         *
         * @param {string} id_name - 需要滾動至的 HTML 元素的 id。
         * 
         * @returns {void} 若找到目標元素，將視窗滾動至該元素；否則，記錄錯誤消息。
         * 
         * @source https://blog.csdn.net/weixin_42776027/article/details/120522684
         */
        scroll_to(id_name) {

            let targetElement = document.querySelector(`#${id_name}`);
            if(targetElement) {
                let elementPosition = targetElement.offsetTop;
                elementPosition += targetElement.offsetParent.offsetTop
                elementPosition -= 150
                window.scrollTo({
                    top: elementPosition,
                    behavior: "smooth",
                    block: "start"
                });
            } else {
                console.log(`Element with id ${id_name} not found`);
            }
            
        },
        async saveMarketingCard() {
            console.log("保存圖卡");
            console.log('type:', this.row)
            console.log('city:', this.selectedCity)
            console.log('district:', this.selectedDistrict)
            console.log(this.start_at);
            console.log(this.end_at);
            console.log(this.campaign_start_at);
            console.log(this.campaign_end_at);
            await this.changeStatus('marketing_card','get_ele_innerHTML', true)
            


            try {
                let is_duplicate = await this.checkSettingDataIsExist()
                let check_all_input_has_value = this.check_all_input_has_value()

                if (is_duplicate === true || !check_all_input_has_value) {
                    this.$root.vtoast.show({
                        message: `請檢查基本設定欄位`,
                    })
                    return
                }
                console.log('this.auto_coupon', this.auto_coupon)
                this.save_load_dialog = true
                let params = {
                    "is_countdown": this.isAutoCoupon,
                    "product_mode": this.marketing_card_setting.product_mode ? 1 : 0,
                    "auto_coupon": this.auto_coupon,
                    "tags": this.row == 0 ? "" : this.selectedDistrict + ',' + this.selectedCity,
                    "setting_name": this.setting_name,
                    "card_content": this.cardInnerHTML,
                    "coupon_id": this.activate_coupon,
                    "preview_url": decodeURIComponent(this.preview_url),
                    // "start_at": new Date(this.start_at).toISOString().split('T')[0] + " " + new Date(this.start_at).toTimeString().split(' ')[0],
                    "start_at": this.parseDateFormat(this.start_at),
                    "campaign_start_at": this.campaign_start_at !== '' && this.campaign_start_at !== null ? this.parseDateFormat(this.campaign_start_at).includes('NaN') ? "" : this.parseDateFormat(this.campaign_start_at) : "",
                    "end_at": this.parseDateFormat(this.end_at),
                    "campaign_end_at": this.campaign_end_at !== '' && this.campaign_end_at !== null ? this.parseDateFormat(this.campaign_end_at).includes('NaN') ? "" : this.parseDateFormat(this.campaign_end_at) : "",
                    "repeat_day": Number(this.repeat_day),
                    "card_hint": this.miniCardInnerhtml,
                    "desktop_card_hint": this.desktopMiniCardInnerHTML,
                    "mobile_card_margin": this.marketing_card_setting.card_mobile_mg_top + 'px 0px 0px 0px',
                    "mobile_card_padding": '0px 5px',
                    "mobile_mini_card_margin": this.marketing_card_setting.card_mobile_mini_mg_top + 'px 0px 0px 0px',
                    "mobile_mini_card_padding": '0px 0px 0px 0px',
                    "desktop_card_margin": '0px' + ' ' + this.marketing_card_setting.card_desktop_mg_right + 'px' + ' ' + this.marketing_card_setting.card_desktop_mg_bottom + 'px' + ' ' + '0px',
                    "container_id": this.$route.params.container_id,
                    "add_column": JSON.stringify({
                        "product_mode": this.marketing_card_setting.product_mode,
                        "timer_off_text": this.marketing_card_setting.timer_off_text,
                        "timer_off_text_color": this.marketing_card_setting.timer_off_text_color,
                        "discount_price": this.marketing_card_setting.discount_price,
                        "discount_price_size": this.marketing_card_setting.discount_price_size,
                        "discount_price_color": this.marketing_card_setting.discount_price_color,
                        "product_text": this.marketing_card_setting.product_text,
                        "product_text_color": this.marketing_card_setting.product_text_color,
                        "product_text_size": this.marketing_card_setting.product_text_size,
                        "warm_up_setting": this.warmUpCardSetting,
                        "end_up_setting": this.endUpCardSetting,
                        "activity_card_setting": this.activityCardSetting,
                        "fill_coupon": this.fill_coupon,
                        "fill_a_code": this.fill_a_code,
                    }),
                    "search_content": ""
                }

                console.log(params);
                console.log(this.marketing_card_setting);

                console.log(this.load_old_setting_data)
                let url_query = this.$route.query;
                let result = '' 
                if (url_query.setting_id) {
                    result = await this.updateCard(params)
                }  
                else {
                    result = await this.createCard(params)
                } 
                console.log('is_check_ok',is_duplicate)
                console.log('check_all_input_has_value', check_all_input_has_value)
                console.log('result:', result)
                
                let is_error = false
                if (!url_query.setting_id) {
                    try {
                        let result_2 = await apiReleaseCard(
                            this.$route.params.org_id, result.id
                        )
                        console.log(result_2)
                    } catch (error) {
                        if (error.includes('interval')) {
                            this.$root.vtoast.show({
                                message: `發布圖卡失敗，原因: ${this.parseDateFormat(this.start_at)} ~ ${this.parseDateFormat(this.end_at)}，能夠發布的圖卡已達方案上限。`,
                            })
                        }
                        else {
                            this.$root.vtoast.show({
                                message: `發布圖卡失敗，原因: ${error}`,
                            })
                        }

                        is_error = true
                    }
                }

                let message = `是否前往預覽網址查看圖卡？`;
                if (parseInt(this.$route.query.setting_id) !== result.id) {
                    await this.$router.replace({
                        path: `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_site/marketing_card/edit`,
                        query: { 
                            setting_id: result.id,
                        }
                    })
                    // await this.$emit('reload')
                    // window.scrollTo({ top: 0, behavior: 'smooth' });
                }
                
                this.save_load_dialog = false
                // this.$root.vtoast.show({
                //     message: `${result.type}圖卡成功！`,
                //     color: 'primary'
                // })
                
                if (!is_error) {
                    this.preview_dialog.is_show = true
                    this.preview_dialog.title = `${result.type}圖卡成功！`
                    this.preview_dialog.text = message
                    this.preview_dialog.result = result
                    // let preview_confirm = confirm(message.toString());
                    // if (preview_confirm) {
                    //     console.log('preview')
                    //     if (result.tags !== '') {
                    //         window.open(this.preview_url + '?opt99-marketing-card=' + this.activate_coupon + '&tags=' + result.tags, '_blank')    			
                    //     } else {
                    //         window.open(this.preview_url + '?opt99-marketing-card=' + this.activate_coupon, '_blank')    			
                    //     }
                    // }
                }
            } catch (error) {
                this.$root.vtoast.show({
                    message: `存檔失敗，原因: ${error}`,
                })
            }
            this.save_load_dialog = false
        },
        async updateCard(params) {
            console.log(params);
            console.log(JSON.parse(params.add_column))
            // Object.values(params).forEach(item => {
            //     console.log(item);
            //     // item.includes('NaN') ? "" : item
            //     if (item.includes('NaN')) {
            //         return ""
            //     } else {
            //         return item
            //     }
            // })
            let result = {}
            // 更新舊圖卡設定檔
            await apiUpdateCard(params, this.$route.params.org_id, this.$route.query.setting_id)
                .then( resp => {
                    console.log(resp);
                    // this.$root.vtoast.show({
					// 	message: "更新圖卡成功！",
                    //     color: 'primary'
					// })
                    result.id = resp.data.data.id
                    result.result = true
                    result.tags = resp.data.data.tags
                    result.type = '更新'
                })
                .catch( error => {
                    console.log('update_error',error);
                    this.$root.vtoast.show({ 
                        message: "更新圖卡失敗，原因: " + error 
                    }) 
                    result.result = false
                    result.tags = ""
                })
            return result    
        },
        async createCard(params) {

            let result = {}
            await apiCreateCard(this.$route.params.org_id, params)
                .then( async resp => {
                    console.log(resp);
                    // await this.$root.vtoast.show({
					// 	message: "新增圖卡成功！",
                    //     color: 'primary'
					// })
                    result.result = true
                    result.id =  resp.data.data.id
                    result.tags = resp.data.data.tags
                    result.type = '新增'
                    // let confirm_dialog = confirm(`圖卡新增成功，請問您要預覽`)
                    //this.$router.push(`/ad/marketing_card/${this.selectedContainer.id}/marketing_card_list`)
                })
                .catch( error => {
                    console.log(error);
                    this.$root.vtoast.show({ message: "新增圖卡失敗，原因: " + error }) 
                    result.result = false
                    result.tags = ""
                })
            return result
        },
        getContainers: async function(){
            let that = this
            let data = []
            data = await apiGetContainers(this.$route.params.org_id).then(function(resp){
            return resp.data.data
            }).catch(function(error){
            console.log(error)
            if (error.response.status === 401) {
                that.$router.push(`/${that.$route.params.org_id}/401`)
            } else {
                that.$root.vtoast.show({
                message: "取得容器失敗，原因: " + error.response ? error.response.data : error
                })
            }
            return []
            })
            return data
        },
        parseDateFormat(dateString) {
            let date = new Date(dateString);

            if (date === 'Invalid Date') {
                alert('有非法的日期')
                return ""
            }
            
            let year = date.getFullYear();
            let month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份是從 0 開始的，所以需要加 1
            let day = date.getDate().toString().padStart(2, '0');
            let hours = date.getHours().toString().padStart(2, '0');
            let minutes = date.getMinutes().toString().padStart(2, '0');
            let seconds = date.getSeconds().toString().padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`

        },
        async readCardSettingAfterTabsChange() {

            console.log(this.newTimeLineMode)

            // 更新左上角標題，給使用者知道現在在編輯哪個區間的圖卡
            await this.$emit('marketing-card-mode', this.newTimeLineMode)
            await this.$emit('get-time-line-mode', this.newTimeLineMode)

            await this.loadOldSettingData()
            await this.$emit('load-old-setting-data', true)
            this.load_old_setting_data = await true

            console.log('_____________2_________________')
            // console.log(this.$store.getters.)
            console.log('_____________2_________________')
        },

        // 將不會改變的欄位同步更新至各時間區間的暫存檔 e.g 圖卡名稱、圖卡代碼等等...
        syncCardSetting(key, value) {
            this.$store.commit('update_activity_card_setting',{ [key] : value })
            this.$store.commit('update_warm_up_card_setting',{ [key] : value })
            this.$store.commit('update_end_up_card_setting',{ [key] : value })
        },
        async onBlur(key, value) {
            console.log("key", key);
            console.log("value", value);

            this.load_old_setting_data = false
            console.log( new Date(value).toString() )

            // 檢查value是不是一個有效的日期
            if (new Date(value).toString() !== "Invalid Date" && key !== 'activate_coupon' && key !== 'setting_name') {
                if ( value !== null && !isNaN(value.getTime()) ) { 
                    value = this.parseDateFormat(value);
                }
            }

            // 日期更改了，要通知父組件更新timeline元件上的日期
            let payload = {
                "key" : key,
                "value" : value
            }
            await this.$emit('get-time-line', payload)

            await this.checkSettingDataIsExist(key, value)
            
            switch (key) {
                case "activate_coupon":
                    key = "coupon_id"
                    break;
            
                default:
                    break;
            }

            await this.syncCardSetting(key, value)
        },
        displayTimer(is_display){
            console.log('change')
            this.syncCardSetting('is_countdown', is_display)
            if (this.oldSettingData) {
                this.changeStatus('old_setting_data','is_countdown', is_display) 
            }
            else {
                this.changeStatus('marketing_card','is_auto_coupon', is_display)
            }
            // oldSettingData !== null ? changeStatus('old_setting_data','is_countdown', isAutoCoupon) : changeStatus('marketing_card','is_auto_coupon', isAutoCoupon)
        },
        changeDisplayMethod(method){
            console.log('method', method)
        },
        async goPreview(){
            this.preview_dialog.is_show = false
            if (this.preview_dialog.result.tags !== '') {
                window.open(this.preview_url + '?opt99-marketing-card=' + this.activate_coupon + '&tags=' + this.preview_dialog.result.tags, '_blank')    			
            } else {
                window.open(this.preview_url + '?opt99-marketing-card=' + this.activate_coupon, '_blank')    			
            }
            await this.$emit('reload')
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        async closePreview(){
            this.preview_dialog.is_show = false
            await this.$emit('reload')
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        async checkAuth(){
            try {
                let functions = [
                    "SalesCardCountdown", "SalesCardProductMode", "SalesCardAutoCoupon"
                ]
                let result = await apiGetOrganizeFunctionStatus(
                    this.$route.params.org_id
                )
                let auth_mapper = {}
                functions.forEach(function(function_name){
                    let target_function = result.quota.find(function(quo){
                        return quo.function === function_name
                    })

                    if (target_function.limit === 0) {
                        auth_mapper[target_function.function] = false
                    }
                    else {
                        auth_mapper[target_function.function] = true
                    }
                })
                console.log('auth_result', auth_mapper)
                console.log('functions', functions)
                this.auth_mapper = auth_mapper
            } catch (error) {
                console.log('auth_error', error)
            }
        },
        updateUrl: function(){
            var paramsArr = []; //用陣列儲存所有參數，以便後續判斷及迴圈計算
            var finalUrl = this.preview_url; //最後我們要的url是建立在base url之上，所以先賦予他base url的值。
            if (!this.preview_url) {
                return
            }
            //將參數都push至陣列中
            paramsArr.push(this.activate_coupon);
            paramsArr.push(this.fill_coupon);
            paramsArr.push(this.fill_a_code);

            //for迴圈對陣列進行處理
            for(var i = 0; i < paramsArr.length; i++){
                if(paramsArr[i] == ''){ //若此參數為空，不用做處理，直接跳下圈
                    continue;
                }   

                if(finalUrl.indexOf("?") == -1){ //檢查url中是否已經帶有參數，如果有帶參數的話在url中會找到"?"
                    finalUrl+='?' //還沒帶參數就加"?"
                }else{
                    finalUrl+='&' //帶過了就加"&"
                }

                switch(i){
                    case(0): //第一個值是行銷圖卡的參數
                        finalUrl+='marketing-card='+this.activate_coupon;
                    break;

                    case (1): //第二個值是優惠代碼的參數
                        finalUrl+='order-coupon='+this.fill_coupon;
                    break;

                    case (2): //第三個值是推薦代碼的參數
                        finalUrl+='affiliate-code='+this.fill_a_code;
                    break;
                }
            }

            return finalUrl;
        },
        async copyResultUrl(){
            console.log('copyResultUrl',this.card_url)
            
            try {
                await navigator.clipboard.writeText(this.card_url);
                this.$root.vtoast.show({
                    color: 'primary',
                    message: `已經複製在剪貼簿囉！`,
                })
            } catch (error) {
                this.$root.vtoast.show({
                    message: `複製失敗，原因: ${error}`,
                })
            }
            
        }
    },
    mounted() {
        console.log("yo MarketingCardSetting");
        console.log('MiniCard innerHTML in MarketingCardSetting:', this.miniCardInnerHTML);
        // this.$refs.displayTimeCountDown.$el.click()
        console.log(typeof this.start_at);
        console.log(typeof this.end_at);
    },
    watch: {
        repeat_day: function(newVal,oldVal) {
            if (newVal !== oldVal) {
                this.$store.commit('repeat_day', Number(this.repeat_day))
            }
        },
        marketing_card: {
            handler: function(newValue) {
                this.marketing_card_setting = newValue
            },
            deep: true,
            immediate: true
        },
        newTimeLineMode: {
            handler: async function(newValue, oldValue) {
                console.log("old", oldValue)
                console.log("new", newValue)
                console.log(this.$route.query.setting_id);
                console.log(this.newTimeLineMode);
                console.log(this.oldTimeLineMode);
                oldValue === undefined ? this.oldTimeLineMode = newValue : this.oldTimeLineMode = oldValue
                console.log(this.oldTimeLineMode);
                await this.saveCardSettingBeforeTabsChange(1)
                await this.readCardSettingAfterTabsChange()
            }
        },
        saveMarketingCardSetting: {
            handler: function(newVal, oldVal) {
                console.log(oldVal)
                if (newVal) {
                    this.saveMarketingCard()
                }

            }
        },
        localModeCardSetting: {
            handler: function(newVal,oldVal) {
                console.log(oldVal);
                console.log(newVal);
                this.localModeCardSetting = newVal
                // this.loadOldSettingData()
            },
            deep: true
        },
        modeCardSetting: {
            handler: function(newVal,oldVal) {
                console.log(oldVal);
                console.log(newVal);
                this.modeCardSetting = newVal
                // this.loadOldSettingData()
            },
            deep: true
        },
        start_at: {
            handler: function(newVal,oldVal) {
                console.log(oldVal)
                console.log(newVal)
                // this.$emit('same-time-line-hint', false)
                if (newVal && oldVal !== newVal) {
                    const new_start_at = this.$utils.parseDateFormat(newVal)
                    console.log(this.$utils.parseDateFormat(newVal))
                    let parsedDate = this.$utils.parseDateFormat(this.campaign_start_at);
                    if (parsedDate === new_start_at && parsedDate !== '' && new_start_at !== '') {
                    // if (this.$utils.parseDateFormat(this.campaign_start_at) === new_start_at) {
                        console.log("1");
                        if (this.$utils.parseDateFormat(this.end_at) === this.$utils.parseDateFormat(this.campaign_end_at)) {
                            console.log("2");
                            this.$emit('same-time-line-hint', true)
                            return
                        }
                    }
                }
            }
        },
        end_at: {
            handler: function(newVal,oldVal) {
                console.log(oldVal)
                console.log(newVal)
                // this.$emit('same-time-line-hint', false)
                if (newVal && oldVal !== newVal) {
                    const new_end_at = this.$utils.parseDateFormat(newVal)
                    console.log(this.$utils.parseDateFormat(newVal))

                    let parsedDate = this.$utils.parseDateFormat(this.campaign_end_at);
                    if (parsedDate === new_end_at && parsedDate !== '' && new_end_at !== '') {

                    // if (this.$utils.parseDateFormat(this.campaign_end_at) === new_end_at) {
                        console.log("1");
                        if (this.$utils.parseDateFormat(this.start_at) === this.$utils.parseDateFormat(this.campaign_start_at)) {
                            console.log("2");
                            this.$emit('same-time-line-hint', true)
                            return
                        }
                    }
                }
            }
        },
        campaign_start_at: {
            handler: function(newVal,oldVal) {
                console.log(oldVal)
                console.log(newVal)
                // this.$emit('same-time-line-hint', false)
                if (newVal && oldVal !== newVal) {
                    const new_campaign_start_at = this.$utils.parseDateFormat(newVal)
                    console.log(this.$utils.parseDateFormat(newVal))
                    let parsedDate = this.$utils.parseDateFormat(this.start_at);
                    console.log(parsedDate);
                    if (parsedDate === new_campaign_start_at && parsedDate !== '' && new_campaign_start_at !== '') {

                    // if (this.$utils.parseDateFormat(this.start_at) === new_campaign_start_at) {
                        console.log("1");
                        if (this.$utils.parseDateFormat(this.end_at) === this.$utils.parseDateFormat(this.campaign_end_at)) {
                            console.log("2");
                            // this.campaign_end_at = this.$utils.parseDateFormat(this.end_at)
                            // this.campaign_start_at = this.$utils.parseDateFormat(new_campaign_start_at)
                            this.$emit('same-time-line-hint', true)
                            return
                        }
                    }
                }
            }
        },
        campaign_end_at: {
            handler: function(newVal,oldVal) {
                console.log(oldVal)
                console.log(newVal)
                // this.$emit('same-time-line-hint', false)
                if (newVal && oldVal !== newVal) {
                    const new_campaign_end_at = this.$utils.parseDateFormat(newVal)
                    console.log(this.$utils.parseDateFormat(newVal))
                    let parsedDate = this.$utils.parseDateFormat(this.end_at);
                    if (parsedDate === new_campaign_end_at && parsedDate !== '' && new_campaign_end_at !== '') {

                    // if (this.$utils.parseDateFormat(this.end_at) === new_campaign_end_at) {
                        console.log("1");
                        if (this.$utils.parseDateFormat(this.start_at) === this.$utils.parseDateFormat(this.campaign_start_at)) {
                            console.log("2");
                            // this.campaign_end_at = this.$utils.parseDateFormat(new_campaign_end_at)
                            // this.campaign_start_at = this.$utils.parseDateFormat(this.start_at)
                            this.$emit('same-time-line-hint', true)
                            return
                        }
                    }
                }
            }
        },
        // is_same_time: {
        //     handler: function(newValue) {
        //         console.log(newValue);
        //         if (newValue) {
        //             this.sameTimeLine()
        //         }
        //     }
        // }
    }    
}

</script>

<style scoped>
    #horizontal-line {
        top: calc(50% - 1px);
        bottom: initial;
    }
    #horizontal-line::before{
        content: "";
        height: 2px;
        position: absolute;
        width: 100%;
        left: 10px;
        right: 0px;
    }
    .preview-hint-container > h4{
        display: flex;
        align-items: center;
        margin-top: 0.5em;

    }
    .preview-hint-container > h4 > i {
        margin-right: 0.5em;
    }
    .preview-container, .setting-container {
        display: flex;
        flex-direction: column;
    }
    .setting-container {
        width: 100%;
        overflow: hidden;
    }
    .setting-main {
        overflow: hidden;
    }
    .setting-main > article{
        background-color: #FFFFFF;
        border-bottom:1px #CCC solid;
        padding: 1em;
        overflow: hidden;
    }

    .setting-main > article:last-child {
        border-bottom: none;
    }

    h4.basic-setting-title {
        margin-bottom:1em;
        padding-left: 0.5em;
        font-weight: 600;
        font-size: 1.6em;
        background-color: rgb(215, 227, 248);
        color: #0077ff;
        border-left: 6px solid #6fadf4;
    }

    div.setting-main > article:nth-child(2) > div > h4 {
        padding-bottom:1em;
        font-weight: 600;
        font-size: 1.4em;
    }

    .setting-main article h5 {
        padding-bottom:1em;
        font-weight: 500;
        font-size: 1.1em;
        display: flex;
    }
    .setting-main article h5 i {
        color: #409aff;
        margin-right: 0.5em;
    }

    .basic-setting-container > .input-container > section {
        align-items: unset;
        flex-direction: column;
    }
    .basic-setting-container > .input-container > section > label {
        margin-bottom: 0.5em;
    }
    .basic-setting-title {	
        display: flex;
    }
    .basic-setting-title > span {
        display: flex;
        align-items: center;
        font-size: 0.7em;
        color: #409aff;
        margin-left: 0.5em;
    }
    .basic-setting-title > span > i{
        font-size: 18px;
        margin-right: 5px;
    }
    .basic-setting-title > span > a{
        font-weight: 200;
        outline: none;
        text-decoration: none;
        color: #409aff;
    }
    .basic-setting-title > span > a:hover {
        text-decoration: underline;
    }
    .input-container {
        display: flex;
        flex-direction: row;
        width: 100%;
        margin-bottom: 1em;
    }

    .input-container #preview_url  { 
        display: flex;
        flex-direction: row;
        width: 100%;
    }

    .input-container > section {
        display: flex;
        width: 100%;
        flex-direction: row;
        margin-right: 1em;
        align-items: center;
    }
    .basic-setting-container > .input-container > section {
        align-items: unset;
        flex-direction: column;
    }
    .basic-setting-container > .input-container > section > label {
        margin-bottom: 0.5em;
    }
    .input-container > section > label > i {
        margin-right: 0.3em;
        color: #409aff;
    }
    .input-container > section > label {
        min-width: 6em;
        display: flex;
        align-items: center;
        margin-right: 0.5em;
    }
    .input-container > section > input[type="text"] {
        padding: 10px 18px 10px 18px;
        border-radius: .4285rem;
        border-color: #2b3553;
        border: 1px solid #cad1d7;
        width: 100%;
        outline: none;
        transition: all .3s;
    }
    .input-container > section > input[type="text"]:hover, .input-container > section > input[type="text"]:focus{
        border-color: #409aff;
    }

    .input-container > section > .mx-datepicker {
        width: 100%;
    }

    .disable_margin {
        margin: 0px;
    }
    .setting-footer {
        padding: 0.5em;
        background-color: #FFF;
        border:1px #CCC solid;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .setting-footer > section {
        display: flex;
        align-items: center;	
    }
    .setting-footer > section > button{
        margin: 0px 1em;
        padding: 2px 20px;
        outline: none;
        background-color: transparent;	
        display: flex;
        border: 1px #FFF solid;
        align-items: center;
        cursor: pointer;
        border-radius: 5px;
        transition: all .3s;	
    }

    .setting-footer > section > #back {
        color: #ff5d41;
        border-color: #ff5d41;
    }
    .setting-footer > section > #back:hover {
        background-color: #ff5d41;
        color: #FFF;
    }

    .setting-footer > section > #save {
        color: #3DCAB5;
        border-color: #3DCAB5;
        background-color: #fff;
    }
    
    .setting-footer > section > #save:hover {
        background-color: #3DCAB5;
        color: #FFF;
    }

    .setting-footer > section > #goBack{
        color: #b1b1b1;
        border-color: #dedfdf;
        background-color: #fff;
    }
    
    .setting-footer > section > #goBack:hover{
        background-color: #aeaeae;
        color: #FFF;
    }
    
    .setting-footer > section > i:hover {
        background-color: #3DCAB5;
        color: #FFF;
    }
    
    /* #save {
        color: #3DCAB5;
        border-color: #3DCAB5;
        background-color: transparent;
    } */
    
    /* .save:hover {
        background-color: #3DCAB5;
        color: #FFF;
    } */
    
    .setting-footer > section > button > i {
        margin-right: 0.3em;
    }

    .required {
        position: relative;
    }

    .required::before {
        content: "*";
        color: red;
        position: absolute;
        margin-right: 5px;
    }

    label:has(+input:required)::before{
        content: '*';
        color: red;
    }
    .message-container {
        border: 1px #f44436 solid;
        border-radius: 5px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .message-container > i {
        color: #f26e6e;
        font-size: 1.3em;
        margin-right: 0.5em;
    }

    .message-container > span {
        color: #f26e6e;
        font-weight: 200;
        font-size: 0.9em;
        font-weight: bold;
    }

    .panel section.column {
        align-items: unset;
        flex-direction: column;
    }

    .panel section label {
        margin-bottom: 0.5em;
    }

    .input-container #preview_url {
        align-items: unset;
        flex-direction: column;
    }
    .app-date-picker >>> .mx-input {
    height: 40px;
    }
    .app-date-picker.error-message >>> .mx-input {
    border-color: #ff1744;
    border-width: 2px;
    }
</style>